import React from 'react'
import { Helmet } from 'react-helmet'
import { organizationSchema } from 'data/schema-data'
import { graphql, useStaticQuery } from 'gatsby'

const Head = () => {
  const {
    site: {
      siteMetadata: { description, title },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          description
          title
        }
      }
    }
  `)
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
      <script type='application/ld+json'>{JSON.stringify(organizationSchema)}</script>
    </Helmet>
  )
}

export default Head
